export default{
    "text_1":  "Digitálna / marketingová agentúra",
    "text_2":  "Foto / video produkcia",
    "text_3":  "Dizajn a grafika", 
    "text_4":  "Stavebníctvo", 
    "text_5":  "Maloobchod a predaj", 
    "text_6":  "Finančné poradenstvo",
    "text_7":  "Iné", 
}